import type NextGenBacklogType from '@jira/spa-apps__next-gen-backlog/src/BacklogWrapper.tsx';
import type { BacklogMetaAPIConsumerWrapperQuery } from '@jira/spa-apps__next-gen-backlog/src/__generated__/BacklogMetaAPIConsumerWrapperQuery.graphql.ts';
import type { EntryPointProps } from 'react-relay';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';

export const LazyBacklogPage: LazyComponent<
	(
		props: EntryPointProps<
			{
				backlogDataQuery: BacklogMetaAPIConsumerWrapperQuery;
			},
			{},
			{},
			{}
		>,
	) => React.JSX.Element
> = lazyForPaint<typeof NextGenBacklogType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-next-gen-backlog", jiraSpaEntry: "next-gen-backlog" */ '@jira/spa-apps__next-gen-backlog/src/BacklogWrapper.tsx'
			),
		),
	{ entryFsSsrLiftImportToModule: true },
);
